/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useState } from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { apiFetch } from "../../../../apiBindings";
import Carousel from "../../Carousel";
import LinkComponent from "../../LinkComponent";
import StarImg from "./Star";

const Container = styled.div`
    background-color: ${({ theme }) => theme.colors.red.toString()};
    ${({ theme }) => theme.paddings.containerOuter.left};
    ${({ theme }) => theme.paddings.containerOuter.right};

    padding: 20px 0;
`;

const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${({ theme }) => theme.colors.white.toString()};
`;

const LeftColumn = styled.div``;

const CenterColumn = styled.div`
    display: flex;
    flex-direction: column;
    margin: 10px 0;
`;

const SpecificsRow = styled.div`
    display: flex;
    column-gap: 10px;
    align-items: center;
    justify-content: space-between;
`;

const FullBar = styled.div`
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.white.toString()};
    border-radius: 1rem;
    height: 1rem;
    width: 200px;
    ${({ theme }) => theme.breakpoints.from.small.css`
       width: 100px;
    `}
    ${({ theme }) => theme.breakpoints.from.medium.css`
       width: 200px;
    `}
`;

const FillBar = styled.div`
    height: 100%;
    background-color: ${({ theme }) => theme.colors.blue.toString()};
    border-radius: 1rem;
`;

const RightColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    font-weight: 900;
`;

const StarsWrapper = styled.div`
    position: relative;
    margin: 10px 0;
`;

const AllStars = styled.div`
    display: flex;

    svg {
        width: 35px;
    }
`;

const Stars = styled.div`
    position: absolute;
    z-index: 1;
    display: flex;

    svg {
        width: 35px;
    }
`;

const VacancyRating = ({ linkOptional }) => {
    const theme = useTheme();
    const [rating, setRating] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        apiFetch(`/rating`)
            .then((response) => response.json())
            .then((responseData) => {
                setRating(responseData.rating);
                setIsLoading(false);
            });
    }, []);

    const getWidth = (value) => {
        return (value / rating.count) * 100;
    };

    const colorWihte = css`
        color: ${theme.colors.white.toString()};
    `;

    return (
        <Container>
            {isLoading ? (
                <Row
                    css={css`
                        height: 150px;
                    `}
                />
            ) : (
                <>
                    <theme.breakpoints.from.small.Matches>
                        <Row>
                            <LeftColumn>
                                <span
                                    css={css`
                                        font-weight: 900;
                                    `}
                                >
                                    {rating.count}
                                </span>{" "}
                                Erfahrungen und Bewertungen <br /> von
                                Mitarbeitern und Bewerbern
                                {linkOptional &&
                                    linkOptional.href &&
                                    linkOptional.text && (
                                        <div
                                            css={css`
                                                margin-top: 10px;
                                            `}
                                        >
                                            <LinkComponent
                                                color="white"
                                                link={linkOptional}
                                                icon="arrow-right"
                                            />
                                        </div>
                                    )}
                            </LeftColumn>
                            <CenterColumn>
                                {rating.specifics.map((item, index) => (
                                    <SpecificsRow key={index}>
                                        <div>
                                            {item.name} ({item.value})
                                        </div>
                                        <FullBar>
                                            <FillBar
                                                css={css`
                                                    width: ${getWidth(
                                                        item.value
                                                    )}%;
                                                `}
                                            />
                                        </FullBar>
                                    </SpecificsRow>
                                ))}
                            </CenterColumn>
                            <RightColumn>
                                <div>{rating.grade}</div>
                                <StarsWrapper>
                                    <AllStars>
                                        {Array(parseInt(rating.starsTotal))
                                            .fill(null)
                                            .map((value, index) => (
                                                <StarImg key={index} />
                                            ))}
                                    </AllStars>
                                    <div
                                        css={css`
                                            position: absolute;
                                            top: 0;
                                            width: ${rating.percent};
                                            height: 100%;
                                            overflow: hidden;
                                        `}
                                    >
                                        <Stars>
                                            {Array(parseInt(rating.starsTotal))
                                                .fill(null)
                                                .map((value, index) => (
                                                    <StarImg
                                                        color={theme.colors.blue.toString()}
                                                        key={index}
                                                    />
                                                ))}
                                        </Stars>
                                    </div>
                                </StarsWrapper>
                                <div>
                                    {rating.stars} / {rating.starsTotal} (
                                    {rating.count})
                                </div>
                            </RightColumn>
                        </Row>
                    </theme.breakpoints.from.small.Matches>
                    <theme.breakpoints.upTo.extraSmall.Matches>
                        <Carousel>
                            <Carousel.Item css={colorWihte}>
                                <div
                                    css={css`
                                        display: flex;
                                        flex-direction: column;
                                        row-gap: 20px;
                                    `}
                                >
                                    <RightColumn>
                                        <div>{rating.grade}</div>
                                        <StarsWrapper>
                                            <AllStars>
                                                {Array(
                                                    parseInt(rating.starsTotal)
                                                )
                                                    .fill(null)
                                                    .map((value, index) => (
                                                        <StarImg key={index} />
                                                    ))}
                                            </AllStars>
                                            <div
                                                css={css`
                                                    position: absolute;
                                                    top: 0;
                                                    width: ${rating.percent};
                                                    height: 100%;
                                                    overflow: hidden;
                                                `}
                                            >
                                                <Stars>
                                                    {Array(
                                                        parseInt(
                                                            rating.starsTotal
                                                        )
                                                    )
                                                        .fill(null)
                                                        .map((value, index) => (
                                                            <StarImg
                                                                color={theme.colors.blue.toString()}
                                                                key={index}
                                                            />
                                                        ))}
                                                </Stars>
                                            </div>
                                        </StarsWrapper>
                                        <div>
                                            {rating.stars} / {rating.starsTotal}{" "}
                                            ({rating.count})
                                        </div>
                                    </RightColumn>
                                    <LeftColumn>
                                        <span
                                            css={css`
                                                font-weight: 900;
                                            `}
                                        >
                                            {rating.count}
                                        </span>{" "}
                                        Erfahrungen und Bewertungen
                                        <br />
                                        von Mitarbeitern und Bewerbern
                                        {linkOptional &&
                                            linkOptional.href &&
                                            linkOptional.text && (
                                                <div
                                                    css={css`
                                                        display: flex;
                                                        flex-direction: column;
                                                        align-items: center;
                                                        margin-top: 20px;
                                                    `}
                                                >
                                                    <LinkComponent
                                                        color="white"
                                                        link={linkOptional}
                                                        extraBold
                                                        icon="arrow-right"
                                                    />
                                                </div>
                                            )}
                                    </LeftColumn>
                                </div>
                            </Carousel.Item>
                            <Carousel.Item css={colorWihte}>
                                <CenterColumn>
                                    <div
                                        css={css`
                                            margin-bottom: 10px;
                                            font-weight: 900;
                                            text-align: center;
                                        `}
                                    >
                                        {rating.count} Bewertungen
                                    </div>
                                    {rating.specifics.map((item, index) => (
                                        <SpecificsRow key={index}>
                                            <div>
                                                {item.name} ({item.value})
                                            </div>
                                            <FullBar>
                                                <FillBar
                                                    css={css`
                                                        width: ${getWidth(
                                                            item.value
                                                        )}%;
                                                    `}
                                                />
                                            </FullBar>
                                        </SpecificsRow>
                                    ))}
                                </CenterColumn>
                            </Carousel.Item>
                        </Carousel>
                    </theme.breakpoints.upTo.extraSmall.Matches>
                </>
            )}
        </Container>
    );
};

export default VacancyRating;
